import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import { RootModel } from '../models';

export const storeName = 'layoutModel';

type LayoutModelTypes = {
  loading: boolean;
  isMobileDevice: boolean;
  navbarConfig: {
    navbarFolded: boolean;
    navbarExpand: boolean;
  };
  locale: string;
};

const initialState: LayoutModelTypes = {
  loading: true,
  isMobileDevice: false,
  navbarConfig: {
    navbarFolded: true,
    navbarExpand: false,
  },
  locale: null,
};

export const layoutModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setLoading: produce((state, payload: boolean) => {
      state.loading = payload;
    }),
    setMobileDevice: produce((state, payload: boolean) => {
      state.isMobileDevice = payload;
    }),
    setNavbarFolded: produce((state, payload: boolean) => {
      state.navbarConfig.navbarFolded = payload;
    }),
    setNavExpand: produce((state, payload: boolean) => {
      state.navbarConfig.navbarExpand = payload;
    }),
    toggleNavbarConfig: produce((state, payload: boolean) => {
      state.navbarConfig.navbarExpand = payload;
      state.navbarConfig.navbarFolded = !payload;
    }),
    setLocale: produce((state, payload: any) => {
      state.locale = payload;
    }),
  },
  effects: (dispatch: RematchDispatch) => ({}),
});

export default layoutModel;
